<template>
  <div class="ushk-table" :class="{'is-border': border}">
    <div class="ushk-table-head">
      <div data-type="fixed">
        <div class="ushk-table-head_wrap">
          <div v-for="(item, index) in items" :key="index" :style="{width: item[1]}"
            class="ushk-table-head_item">{{ item[0] }}</div>
        </div>
      </div>
    </div>
    <table class="ushk-table_body">
      <colgroup>
        <col v-for="(item, index) in items" :key="index" :width="item[1]" />
      </colgroup>
      <tbody>
        <tr v-if="!datas">
          <td colspan="9">加载中......</td>
        </tr>
        <template v-else>
          <template v-if="datas.length">
            <tr v-for="(data, index) in datas" :key="index">
              <td>{{ data.pub_time.split(' ')[0] }}</td>
              <td v-if="isList"><button class="ushk-report__name" @click="showReport(data)">{{ data.name }}</button></td>
              <td>
                <span>{{ data.previous_rating }}</span>
                <icon v-if="data.previous_rating && data.latest_rating" type="arrow"></icon>
                <span>{{ data.latest_rating }}</span>
              </td>
              <td>
                <span>{{ data.previous_target_price || '' }}</span>
                <icon v-if="data.previous_target_price && data.latest_target_price" type="arrow" :class="parseInt(data.previous_target_price) > parseInt(data.latest_target_price ) ? 'is-green' : 'is-red'"></icon>
                <span>{{ data.latest_target_price || '' }}</span>
              </td>
              <td>{{ data.institution }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="9">{{ noneText }}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="ushk-more">
      <a v-if="isShowMore" @click="lower" class="ushk-more__btn" :class="{'is-loading': isLoading}" href="javascript:;">
        <i class="ushk-icon ushk-icon_expand"></i>点击加载更多</a>
    </div>
  </div>
</template>
<script>
  import getData from './getData'
export default {
    props: {
      type: String,
      border: Boolean,
      data: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {
        noneText: '暂无数据',
        limit: 0,
        items: [],
        datas: false,
        isShowMore: false,
        isLoading: false,
        offset: undefined
      }
    },
    computed: {
      isList () {
        return !Object.keys(this.data).length && !this.data.name
      },
      unit () {
        return this.type === 'us' ? '美元' : '港币'
      }
    },
    mounted () {
      let payload = { type: this.type }
      if (this.isList) {
        this.items = [
        ['日期', '15%'],
        ['个股名称', '20%'],
        ['评级', '25%'],
        [`目标价（${this.unit}）`, '20%'],
        ['机构名称', '20%']
        ]
      } else {
        this.items = [
        ['日期', '20%'],
        ['评级', '30%'],
        [`目标价（${this.unit}）`, '25%'],
        ['机构名称', '25%']
        ]
        payload.indicatorId = this.data.indicator_id
      }
      this.getData(payload).then(({list}) => {
        this.datas = list
      })
    },
    methods: {
      getData (payload) {
        return new Promise((resolve, reject) => {
          this.isLoading = true
          getData(payload).then((res) => {
            this.isLoading = false
            if (res.status !== 200) {
              reject()
              return false
            }
            const {data} = res
            this.offset = data.offset
            this.isShowMore = data.list.length >= this.limit
            resolve(data)
          }).catch(() => {
            this.isLoading = false
          })
        })
      },
      lower () {
        let indicatorId
        let lastDate
        let offset = this.offset
        let length = this.datas.length
        if (!this.isList) {
          indicatorId = this.data.indicator_id
        }
        if (length) {
          const lastData = this.datas[length - 1]
          lastDate = lastData.pub_time.split(' ')[0]
        }
        this.getData({
          type: this.type,
          indicatorId,
          lastDate,
          offset
        }).then(({list}) => {
          this.datas = this.datas.concat(list)
        })
      },
      showReport (data) {
        this.$emit('show-report', {
          data,
          type: this.type
        })
      }
    }
}
</script>



// WEBPACK FOOTER //
// Content.vue?416dc940